import React from 'react';
import { Link } from "react-router-dom";
import Deals from './deals';
import OwlCarousel from 'react-owl-carousel2';
import {OwlCarouselOptions} from '../../../constants';

const Category = (props) => {
    return (
        <React.Fragment>
            <div className="category-header">
                <h4 className="category-heading"><span className="shining-text">{props.category.name}</span></h4>
                <Link to={process.env.PUBLIC_URL+'/oneday/category-deals/?categories='+props.category._id} className="view-all-bitn animate_btn ml-auto">View All</Link>
            </div>
            <div className={props.index===0 && props.similar_vendor_count > 0 ? "each-category-outer selected" : "each-category-outer mb-4"}>
                <OwlCarousel options={OwlCarouselOptions} className="owl-carousel owl-theme">
                    <Deals deals={props.category.deals}/>
                </OwlCarousel>
            </div>
        </React.Fragment>
    );
}

export default Category;